import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-ZTDB',
        },
    },
    host: 'www.zalando-lounge.at',
});
